import { render, staticRenderFns } from "./HrSolid.vue?vue&type=template&id=66886a50&scoped=true&"
import script from "./HrSolid.vue?vue&type=script&lang=js&"
export * from "./HrSolid.vue?vue&type=script&lang=js&"
import style0 from "./HrSolid.vue?vue&type=style&index=0&id=66886a50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66886a50",
  null
  
)

export default component.exports